export default __webpack_public_path__ + "static/media/ic_sad_view.010176cc.png";